import styled from 'styled-components';

const BlackHeader = styled.div`
  background-color: #4a4a4a;
  padding: 15px;
`;

const NonBlackHeader = styled.div`
  padding: 15px;
`;

export {
  BlackHeader,
  NonBlackHeader
}